/**
 * API Configuration Utility
 * Handles backend URL detection for both preview and production environments
 */

// Get the correct backend URL based on environment
export const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  
  console.log('[API Config] ENV URL:', envUrl);
  console.log('[API Config] Current hostname:', currentHostname);
  console.log('[API Config] Current origin:', currentOrigin);
  
  // If we're on localhost, always use the ENV URL (development/preview mode)
  if (currentHostname === 'localhost' || currentHostname === '127.0.0.1') {
    console.log('[API Config] Localhost detected, using ENV URL');
    return envUrl || currentOrigin;
  }
  
  // If we're on ANY emergent.host domain (production OR preview), use current origin
  // This ensures frontend and backend are on same domain (no CORS issues)
  if (currentHostname && (currentHostname.includes('.emergent.host') || currentHostname.includes('.emergentagent.com') || currentHostname === 'radio-apps.online')) {
    console.log('[API Config] Production/Emergent domain detected! Using window.location.origin');
    return currentOrigin;
  }
  
  // Return env URL if set, otherwise use current origin
  const finalUrl = envUrl || currentOrigin;
  console.log('[API Config] Final backend URL:', finalUrl);
  return finalUrl;
};

// Export the backend URL for use across the app
// Note: This is evaluated at module load time, use getBackendUrl() for runtime evaluation
export const BACKEND_URL = typeof window !== 'undefined' ? getBackendUrl() : '';

// API base URL (with /api prefix)
export const API_URL = `${BACKEND_URL}/api`;

export default {
  getBackendUrl,
  BACKEND_URL,
  API_URL
};
